export default __webpack_public_path__ + "static/media/pattern.366d02aa.svg";